import React from 'react';
import PropTypes from 'prop-types';
import Img from '@src/components/Img';
import NLink from '@src/components/NLink';

import css from './style.module.scss';

const NavCard = (props) => {
	const { title, isShallow, href, src, forceVisibility } = props;

	return (
		<div className={css.base}>
			<div className={css.media}>
				<Img
					src={src}
					width={112}
					height={84}
					alt={title}
					forceVisibility={forceVisibility}
				/>
			</div>
			<NLink href={href} shallow={isShallow}>
				<a className={css.link} />
			</NLink>
			{title && (
				<div className={css.title}>
					<span className={css.text}>{title}</span>
				</div>
			)}
		</div>
	);
};

NavCard.propTypes = {
	title: PropTypes.string,
	isShallow: PropTypes.bool,
	href: PropTypes.string,
	src: PropTypes.string,
	forceVisibility: PropTypes.bool,
};

NavCard.defaultProps = {
	title: undefined,
	isShallow: false,
	href: '',
	src: undefined,
	forceVisibility: false,
};

export default NavCard;
